import './index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { PostHogProvider } from './lib/posthog/PostHogProvider';
import { ErrorBoundaryFallback } from './modules/errors/components/errorBoundaryFallback/ErrorBoundaryFallback';
import { claimStaleChunkReload } from './modules/errors/staleChunk';

// Vite fires this when a lazy chunk fails to load, typically a tab still on
// the previous deploy. The error still reaches RouteErrorBoundary (App.tsx).
window.addEventListener('vite:preloadError', () => {
  if (claimStaleChunkReload(window.sessionStorage, Date.now())) {
    window.location.reload();
  }
});

// `pnpm dev:mock` serves fixture API responses from src/mocks. Production
// builds drop this branch, so the mocks never ship.
const enableMocking = async () => {
  if (import.meta.env.MODE !== 'mock') return;

  const { worker } = await import('./mocks/browser');
  await worker.start({ onUnhandledRequest: 'bypass' });
};

enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <PostHogProvider errorFallback={<ErrorBoundaryFallback />}>
        <App />
      </PostHogProvider>
    </StrictMode>,
  );
});
